import * as React from 'react'

import * as SeparatorPrimitive from '@radix-ui/react-separator'
import { styled } from 'styled-components'

import * as tokens from '../../styles/tokens'

// Re-exporting the Radix Root component
export const SeparatorRoot = SeparatorPrimitive.Root

// Default props for the Separator, can be expanded
export type SeparatorProps = React.ComponentPropsWithoutRef<
  typeof SeparatorPrimitive.Root
> & {
  // Add any custom props if needed, e.g., for custom styling variants
}

// The main Separator component to be used in the app
export const Separator: React.FC<SeparatorProps> = React.forwardRef<
  React.ElementRef<typeof StyledSeparator>,
  SeparatorProps
>(
  (
    { orientation = 'horizontal', decorative = true, ...props },
    forwardedRef,
  ) => (
    <StyledSeparator
      decorative={decorative}
      orientation={orientation}
      ref={forwardedRef} // Per Radix docs, if it's purely visual, set decorative
      {...props}
    />
  ),
)

Separator.displayName = 'Separator'

// A basic styled version of the Separator.Root
// Moved to the end as per style guide.
const StyledSeparator = styled(SeparatorPrimitive.Root)`
  background-color: ${(props) =>
    props.theme.border ||
    tokens.outline}; /* UPDATED: Use tokens.outline as fallback */

  &[data-orientation='horizontal'] {
    margin: 8px 0; /* Example margin for horizontal */
    width: 100%;
    height: 1px;
  }

  &[data-orientation='vertical'] {
    margin: 0 8px; /* Example margin for vertical */
    width: 1px;
    height: 100%;
  }
`
